import type { HelpTopic } from '../help/topics';
import type { StringKey } from '../strings';

/**
 * 🔒 The Intent card's four rows as the card explains them (T252; decision 0724):
 * the one line under each row's name saying what turns it green, and the help
 * topic each row has, which the card's head opens together in row order.
 *
 * 🔨 The rule is the server's and the line only says it: Budget and Timing follow
 * their saved answer, Authority and Need follow the tick, and the stage's own
 * guard asks every ticked row for a note (piece 18).
 */
export const BANT_ROWS = ['Budget', 'Authority', 'Need', 'Timing'] as const;
export type BantRow = (typeof BANT_ROWS)[number];

export const BANT_ROW_RULES: Readonly<Record<BantRow, StringKey>> = {
  Budget: 'deal.card.rule.budget',
  Authority: 'deal.card.rule.authority',
  Need: 'deal.card.rule.need',
  Timing: 'deal.card.rule.timing',
};

export const BANT_ROW_TOPICS: Readonly<Record<BantRow, HelpTopic>> = {
  Budget: 'dealBudget',
  Authority: 'dealAuthority',
  Need: 'dealNeed',
  Timing: 'dealTiming',
};

/** The rule line for a row, or null for a row that is not one of the four. */
export function bantRowRule(subStage: string): StringKey | null {
  return (BANT_ROWS as readonly string[]).includes(subStage) ? BANT_ROW_RULES[subStage as BantRow] : null;
}
